import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {Observable, of} from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {AssetTemplateSelectorDialogDataModel} from './asset-template-selector-dialog-data.model';
import {
	AssetTemplateSelectCopySettings,
	AssetTemplateSelectElement,
	AssetTemplateSelectionChangeEvent,
	AssetTemplateSelectUiSettings
} from '../asset-template-selector/asset-template-selector.model';
import { AssetTemplateSelectorComponent } from "../asset-template-selector/asset-template-selector.component";
import { SharedPipeModule } from "../../pipes/shared-pipe.module";
import { CommonModule } from "@angular/common";
import { materialModules } from "../../../angular-material.module";
import { AddTemplateDialogDataModel } from "../add-template-dialog/add-template-dialog.component";

@Component({
	selector: 'app-asset-template-selector-dialog',
	standalone: true,
	imports: [
		CommonModule,
		...materialModules,
		SharedPipeModule,
		AssetTemplateSelectorComponent
	],
	templateUrl: './asset-template-selector-dialog.component.html',
	styleUrls: ['./asset-template-selector-dialog.component.scss']
})
export class AssetTemplateSelectorDialogComponent implements OnInit {

	@Output() add: EventEmitter<AddTemplateDialogDataModel | null> = new EventEmitter<AddTemplateDialogDataModel | null>();

	readonly DEFAULT_SETTINGS: AssetTemplateSelectorDialogDataModel = {
		elementTitle: 'Asset',
		elementTitlePlural: 'Assets',
		selectType: 'single',
		viewMode: 'card',
		viewModeOptions: [],
		allowEmptySelection: false,
		showSelectedCount: true,
		showFilter: true,
		showSearch: true,
		showFileTypeFilter: false,
		showFileType: false,
		showRecent: false,
		showCategory: true,
		showMoreFilters: true,
		showSelectViewMode: true,
		showAddButton: true,
		showCancelButton: true,
		showSubmitButton: true,
		showPackageMenuActions: false,
		showImportButton: false,
		showFeatured: true,
		groupByCategory: true,
		showPreview: true,
		elements: of([]),
		selectedElements: [],
		tableCollection: null,
		gridCollection: null,
		customFilters: [],
	};

	readonly DEMO_ELEMENTS : AssetTemplateSelectElement[] =
		[
			// { id: '1', name: 'Asset name 1', isFeatured: true, fileType: 'video', isRecent: false, category: {id: 'cat-1', name: 'Category 1', subCategory: {id: 'sub1-1', name: 'Sub category 1'}}, tags: ['Tag1-1', 'Tag1-2'], thumbnailUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1683826569/video_builder/video_originals/ARM_BlueCruise/FPDE4267000H_2023_GTBS_30_Blue_Cruise_Platinum.jpg', previewUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1683826606/video_builder/video_proxies/FPDE4267000H_2023_GTBS_30_Blue_Cruise_Platinum_Proxy.mp4'},
			// { id: '2', name: 'Asset name 2', isFeatured: true, fileType: 'image', isRecent: false, category: {id: 'cat-1', name: 'Category 1', subCategory: {id: 'sub1-1', name: 'Sub category 1'}}, tags: ['Tag2-1', 'Tag2-2'], thumbnailUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1688129277/video_builder/video_originals/Spanish/20230629_FORD_GTB/20230629_BRONCO_SPORT_HM_DELIVERABLES/VIDEO/FPDE4343000H_2023_GTBS_BCSP_15_Outer_Banks2_HM.jpg', previewUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1688129277/video_builder/video_originals/Spanish/20230629_FORD_GTB/20230629_BRONCO_SPORT_HM_DELIVERABLES/VIDEO/FPDE4343000H_2023_GTBS_BCSP_15_Outer_Banks2_HM.jpg'},
			// { id: '4', name: 'Asset name 4', isFeatured: true, fileType: 'logo', isRecent: false, category: {id: 'cat-1', name: 'Category 1', subCategory: {id: 'sub1-2', name: 'Sub category 1 - 2'}}, tags: ['Tag4-1', 'Tag4-2'], thumbnailUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1683826569/video_builder/video_originals/ARM_BlueCruise/FPDE4267000H_2023_GTBS_30_Blue_Cruise_Platinum.jpg', previewUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1688129277/video_builder/video_originals/Spanish/20230629_FORD_GTB/20230629_BRONCO_SPORT_HM_DELIVERABLES/VIDEO/FPDE4343000H_2023_GTBS_BCSP_15_Outer_Banks2_HM.jpg'},
			// { id: '3', name: 'Asset name 3', isFeatured: true, fileType: 'video', isRecent: false, category: {id: 'cat-2', name: 'Category 2', subCategory: {id: 'sub2-1', name: 'Sub category 2 - 1'}}, tags: ['Tag3-1', 'Tag3-2'], thumbnailUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1683826569/video_builder/video_originals/ARM_BlueCruise/FPDE4267000H_2023_GTBS_30_Blue_Cruise_Platinum.jpg', previewUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1688129277/video_builder/video_originals/Spanish/20230629_FORD_GTB/20230629_BRONCO_SPORT_HM_DELIVERABLES/VIDEO/FPDE4343000H_2023_GTBS_BCSP_15_Outer_Banks2_HM.jpg'},
			// { id: '5', name: 'Asset name 5', isFeatured: true, fileType: 'video', isRecent: true, category: {id: 'cat-2', name: 'Category 1', subCategory: {id: 'sub2-2', name: 'Sub category 2 - 2'}}, tags: ['Tag5-1', 'Tag5-2'], thumbnailUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1683826569/video_builder/video_originals/ARM_BlueCruise/FPDE4267000H_2023_GTBS_30_Blue_Cruise_Platinum.jpg', previewUrl: 'https://res.cloudinary.com/dh3gpwrps/video/upload/v1688129277/video_builder/video_originals/Spanish/20230629_FORD_GTB/20230629_BRONCO_SPORT_HM_DELIVERABLES/VIDEO/FPDE4343000H_2023_GTBS_BCSP_15_Outer_Banks2_HM.jpg'},
		]

	public data: AssetTemplateSelectorDialogDataModel;
	public elements$: Observable<AssetTemplateSelectElement[]>;
	public selectedElements: AssetTemplateSelectElement[] = [];


	constructor(
		public dialogRef: MatDialogRef<AssetTemplateSelectorDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		data: AssetTemplateSelectorDialogDataModel
	) {

		this.data = {...this.DEFAULT_SETTINGS, ...data};

		this.selectedElements = data.selectedElements || [];
		// this.elements$ = of(this.DEMO_ELEMENTS);
		this.elements$ = data.elements;
		// console.log(this.DEMO_ELEMENTS, this.selectedElements);
	}

	ngOnInit() {
	}

	public confirm() {
		this.dialogRef.close(this.selectedElements);
	}

	public dismiss() {
		this.dialogRef.close();
	}

	onSelectionChange({selection, openSelection}: AssetTemplateSelectionChangeEvent) {
		this.selectedElements = selection;

		if (openSelection) {
			this.confirm();
		}
	}

	public generateAssetTemplateSelectUiSettings(data: AssetTemplateSelectorDialogDataModel): AssetTemplateSelectUiSettings {
		return {
			showFilter: data.showFilter,
			showSearch: data.showSearch,
			showFileTypeFilter: data.showFileTypeFilter,
			showFileType: data.showFileType,
			showRecent: data.showRecent,
			showCategory: data.showCategory,
			showMoreFilters: data.showMoreFilters,
			showSelectViewMode: data.showSelectViewMode,
			showAddButton: data.showAddButton,
			showCancelButton: data.showCancelButton,
			showFeatured: data.showFeatured,
			groupByCategory: data.groupByCategory,
			showPreview: data.showPreview,
			customFilters: data.customFilters,
			showSubmitButton: data.showSubmitButton,
			showPackageMenuActions: data.showPackageMenuActions,
			showImportButton: data.showImportButton
		}
	}

	public generateAssetTemplateSelectCopySettings(data: AssetTemplateSelectorDialogDataModel): AssetTemplateSelectCopySettings {
		return {
			title : data.title,
			elementTitle: data.elementTitle,
			elementTitlePlural: data.elementTitlePlural,
			featuredTitle: data.featuredTitle || 'Featured',
			recentTitle: data.recentTitle || 'Recently Added',
			searchPlaceholder: data.searchPlaceholder || 'Search',
			noResultsText: data.noResultsText || 'No results',
		}
	}

}
